/**
 * Miansai: keeps the Nosto cart drawer placement (cartpage-nosto-1) in step with the bag.
 * Reloads it after the ajax cart changes, and credits Nosto when a "+ ADD" from one of its
 * drawer tiles ends in an add. Last changed 2026-10-15: one trigger, no fetch patch.
 */
(function () {
  'use strict';

  var PLACEMENT = 'cartpage-nosto-1';
  if (!document.getElementById(PLACEMENT) || typeof window.jQuery !== 'function') return;

  function text(el, sel) { return ((el.querySelector(sel) || {}).textContent || '').trim(); }
  function sigOf(items) { return items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(); }

  /* Start from the bag as the page rendered it (Nosto's own cart tagging), so the quickshop
     reloading the cart when it opens does not count as a change */
  var lastCart = sigOf([].map.call(document.querySelectorAll('.nosto_cart .line_item'), function (li) {
    return { variant_id: text(li, '.sku_id'), quantity: text(li, '.quantity') };
  }));
  var pendingHandle = '';
  var timer;

  /* "+ ADD" on a drawer tile opens the quickshop; remember which product it was for */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#' + PLACEMENT + ' .quick-shop-trigger');
    if (trigger) pendingHandle = (trigger.getAttribute('data-url') || '').split('/products/')[1] || '';
  }, true);

  window.jQuery(document.body).on('afterCartLoad.ajaxCart', function (evt, cart) {
    if (!cart || !cart.items || typeof window.nostojs !== 'function') return;

    var sig = sigOf(cart.items);
    if (sig === lastCart) return;
    lastCart = sig;

    var added = pendingHandle && cart.items.filter(function (i) { return i.handle === pendingHandle; })[0];
    pendingHandle = '';

    clearTimeout(timer);
    timer = setTimeout(function () {
      window.nostojs(function (api) {
        if (added) api.recommendedProductAddedToCart(String(added.product_id), PLACEMENT);
        api.createRecommendationRequest({ includeTagging: true }).setElements([PLACEMENT]).load();
      });
    }, 350);
  });
})();